module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAADySURBVEiJ3ZQ9bsMwDIU/IpWXXqQn6NJco86UMeghunTpKQpkzkUyNHuAXCZmBqmGoUhUHAsukAcYFsFHPjzqB3JY6zNtp7TdIctZ6bvnnL9ylKdsMYAzs9AAHSB5yjSBRfgMeO2N/oK+FtqNhOz5kaV34Go3B9A3+hGVRjEBMwk0gIYdqfnvBeyzVMlBAfrpD5x86x0C7gbLw4rRI+o3eZBJxrHbMj8SiO0nxuGs/DU/CEhEMmKHnY/iv5scQhmQ4tiv9SN+2QTZ5uqTDq4bFGHUJ25y2rLsjLwx4oRAycG4+FEeuxkETsBL5d7Hyv3+CRcwLUaDWm0dbgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/dakaxq.png
// module id = HD/V
// module chunks = 0